import { ExceptionsClient } from "../client/ExceptionsClient";
import { isNonEmptyString } from "../../util/CommonUtils";
import {UNAUTHORISED_USER, UNAUTHORISED_USER_IDENTIFIED} from "../constants/ScrubConstants";

export function markForScrub({targetUseCase, allItems, allItemsObject}, dispatcher) {
    const scrubCategoryShipments = Object.values(allItemsObject)
                                  .filter(({CATEGORY}) => isNonEmptyString(CATEGORY))
                                  .filter(item => allItems.includes(item.TRACKING_NUMBER))
                                  .map(({TRACKING_NUMBER, CATEGORY}) => ({scannableId: TRACKING_NUMBER, exceptionCategory: CATEGORY}))
    ExceptionsClient.markForScrub({
        targetUseCase : targetUseCase,
        scrubShipments : allItems,
        scrubCategoryShipments : scrubCategoryShipments
    }).then(({valid, data}) => {
        if(valid && data.success) {
            dispatcher({
                type: "SET_STATUS",
                data:  "success",
                additionalInfo: {
                    errorCode: data.errorCode,
                    failedItems: data.failedScrubShipments
                }
            });
        } else if(valid && !data.success && data.errorCode === UNAUTHORISED_USER_IDENTIFIED) {
            dispatcher({
                type: "UNAUTHORISED_USER",
                data:  UNAUTHORISED_USER,
                additionalInfo: {
                    errorCode: data.errorCode,
                    failedItems: data.failedScrubShipments
                }
            });
        }
        else {
            dispatcher({
                type: "SET_STATUS",
                data: "error",
                additionalInfo: {
                    errorCode: data.errorCode,
                    failedItems: data.failedScrubShipments
                }
            });
        }

    });
}

/**
 *
 * @param itemsToUpdate for requesting remove from missing queue
 * @param dispatcher to update response on screen
 */
export function removeFromMissingQueue(itemsToUpdate, dispatcher) {
    ExceptionsClient.updateScrubShipments({
        scrubShipmentAttributes : itemsToUpdate,
        targetUseCase: "MISSING"
    }).then(response => {
        dispatcher({
            type: "REMOVE_MISSING_UPDATED",
            data: {
                message: response.valid ? getParsedResponse(response) : "remove_missing_failure",
                items: itemsToUpdate,
                errorCode: response.errorCode
            }
        });
    });
}

/**
 *
 * @param itemsToUpdate for reverting to queue, this is a singular list
 * @param dispatcher to update response on screen
 * @param reviewMissingStatusConfirm for updating the response list on screen
 */
export function revertToMissingQueue(itemsToUpdate, dispatcher, reviewMissingStatusConfirm) {

    ExceptionsClient.updateScrubShipments({
        scrubShipmentAttributes : itemsToUpdate,
        targetUseCase: "MISSING"
    }).then(response => {
        dispatcher({
            type: "REVERT_TO_MISSING_QUEUE_UPDATED",
            data: response.valid ?
                getTrackingIdParsedResponse(response.data.updateShipmentsResponse, reviewMissingStatusConfirm) :
                getTrackingIdParsedFailureResponse(itemsToUpdate[0].scannableId, reviewMissingStatusConfirm, response)
        });
    });
}

/**
 *
 * @param scannables for updating to terminal scan, this is a singular list
 * @param targetStatus for updating to terminal scan for scannable
 * @param shipmentType shipmentType of the scannable
 * @param dispatcher to update response on screen
 * @param reviewMissingStatusConfirm for updating the response list on screen
 */
export function updateTerminalScan(scannables, targetStatus, shipmentType, dispatcher, reviewMissingStatusConfirm) {
    ExceptionsClient.updateTerminalScan({
        scannableIds: scannables,
        targetStatus: targetStatus,
        shipmentType: shipmentType
    }).then(response => {
        dispatcher({
            type: "REVERT_TO_MISSING_QUEUE_UPDATED",
            data: response.valid ?
                getTrackingIdParsedResponse(response.data.statusUpdateResponses, reviewMissingStatusConfirm) :
                getTrackingIdParsedFailureResponse(scannables[0], reviewMissingStatusConfirm, response)
        });
    });
}

/**
 *
 * @param response from remove from missing queue request
 * @returns parse all responses and return response string for front end translation
 */
function getParsedResponse(response) {
    let success = false;
    let failure = false;
    response.data.updateShipmentsResponse.forEach(data => {
        if (data.success) {
            success = true;
        } else {
            failure = true;
        }
    });

    return (success && failure) ? "remove_missing_partial_failure"
        : (success ? "remove_missing_success" : "remove_missing_failure");
}

/**
 *
 * @param response success from update or revert to missing request
 * @param reviewMissingStatusConfirm argument to update the map wise response of tracking ids
 * @returns map of responses for tracking ids
 */
function getTrackingIdParsedResponse(response, reviewMissingStatusConfirm) {
    response.forEach(data => {
        reviewMissingStatusConfirm[data.scannableId] = data.success
    });

    return reviewMissingStatusConfirm;
}

/**
 *
 * @param scannableId to construct failure response
 * @param reviewMissingStatusConfirm argument to update the map wise response of tracking ids
 * @param response
 * @returns map of responses for tracking ids, this will only contain failures
 */
function getTrackingIdParsedFailureResponse(scannableId, reviewMissingStatusConfirm, response) {
    reviewMissingStatusConfirm[scannableId] = false
    return {reviewMissingStatusConfirm, errorCode: response.errorCode};
}


// WEBPACK FOOTER //
// ./src/commons/api/ScrubUpdateAPI.js